// Shared survey definitions. Imported by:
// - Encuesta.js / EncuestaAdmin.js (browser, via ESM-style import)
// - scripts/build-encuesta-previews.js (Node, via require)
//
// Uses module.exports so the same file works in both contexts. CRA's webpack
// treats CommonJS and ESM imports interchangeably.
//
// Each entry has an optional `seo` block for per-encuesta WhatsApp / social
// preview cards generated at build time.

const ENCUESTAS = {
  '26052026': {
    titulo: 'Breve encuesta CANIMOLT',
    intro:
      'Dado a lo acordado en el Consejo Directivo les pedimos nos contesten ' +
      'las siguientes 2 preguntas:',
    seo: {
      title: 'Breve encuesta CANIMOLT',
      description:
        'Dado a lo acordado en el Consejo Directivo les pedimos nos contesten las siguientes 2 preguntas.',
      // Custom share card with CANIMOLT logo + "ENCUESTA" overlay. Generated
      // manually with ImageMagick; see scripts/make-share-encuesta.sh.
      // Bump the filename (-v2, -v3…) any time the design changes so
      // WhatsApp + Cloudflare have to fetch a fresh URL.
      image: '/share-encuesta-v3.jpg',
    },
    preguntas: [
      {
        id: 'p1_alim_2026',
        csvLabel: 'ALIM 2026 (interés)',
        texto:
          '¿Estaría interesado en participar en el próximo ALIM, que se celebrará en ' +
          'República Dominicana del 22 al 25 de noviembre?',
        nota: { tipo: 'enlace', texto: 'Más información:', url: 'https://alim2026.com', label: 'alim2026.com' },
        opciones: ['Sí', 'No', 'Pudiera ser'],
      },
      {
        id: 'p2_comida_fin_anio',
        csvLabel: 'Comida fin de año (mover al 3-dic)',
        texto:
          'Toda vez que la comida de fin de año de CANIMOLT está programada para el ' +
          'próximo 26 de noviembre, agradeceremos nos confirme si, de acuerdo con su ' +
          'agenda, sería posible modificarla al 3 de diciembre.',
        nota: { tipo: 'texto', texto: '(Ya se revisó disponibilidad en el restaurante Estoril.)' },
        opciones: ['Sí', 'No'],
      },
    ],
  },
};

module.exports = { ENCUESTAS };
